export default __webpack_public_path__ + "static/media/forensic.05bd6754.svg";